<template>
  <div class="page-profile edit">
    <h1 class="user-name-title hide-mobile">{{ $localized(user.localized_name, user.first_name) }} {{ $localized(user.localized_surname, user.last_name) }}</h1>
    <div class="user-block clearfix">
      <label class="avatar-edit">
        <Avatar size="xl" :src="avatarUrl || user.avatar" :online="user.online">
          {{ $t('pages.profile.edit.add-avatar-photo') }}
        </Avatar>
        <div class="btn-add hide-mobile"><img src="@/assets/icons/plus.svg" alt="add"/></div>
        <input type="file" @change="setAvatar" accept="image/*"/>
      </label>
      <div class="info hide-pc">
        <div class="name">{{ $localized(user.localized_name, user.first_name) }} {{ $localized(user.localized_surname, user.last_name) }}</div>
        <Role :role="user.role"/>
      </div>
      <div class="textarea">
        <Tooltip :text="$t('pages.profile.edit.description-input-tooltip')">
          <textarea class="about edit" rows="4" v-model="form.description"></textarea>
        </Tooltip>
        <div class="max-char">{{ form.description.length || 0 }} / 500</div>
      </div>
    </div>
    <div class="profile-info">
      <div>
        <div class="block-title">{{ $t('pages.profile.edit.profile.fio.title') }}</div>
        <div class="tab-list">
          <button v-for="(key, i) in langList" :key="i" @click="activeLangKey = key" class="item bordered" :class="{'active':activeLangKey === key}">{{ key }}</button>
        </div>
        <div class="inputs">
          <input
              type="text"
              :placeholder="$t('name')"
              v-model="form.localized_name[activeLangKey]"
          />
          <input
              type="text"
              :placeholder="$t('surname')"
              v-model="form.localized_surname[activeLangKey]"
          />
        </div>
      </div>
      <div class="about">
        <div class="block-title">{{ $t('pages.profile.edit.profile.about.title') }}</div>
        <div class="inputs">
          <Birthdays class="input-select" v-model="form.birthday">
            <IsShowParam v-model="form.birthday_visible"/>
          </Birthdays>
          <input
              type="text"
              :placeholder="$t('pages.profile.edit.profile.about.form.placeholders.education')"
              v-model="form.education"
          />
          <Tooltip :text="$t('pages.profile.edit.profile.about.form.degree-tooltip')">
            <input
                type="text"
                :placeholder="$t('pages.profile.edit.profile.about.form.placeholders.degree')"
                v-model="form.degree"
            />
          </Tooltip>
          <div
              v-for="(study, i) in form.study"
              :key="i"
              class="input-with-delete"
          >
            <input
                type="text"
                :placeholder="$t('pages.profile.edit.profile.about.form.placeholders.study')"
                v-model="form.study[i]"
            />
            <button v-if="i > 0" @click="deleteStudy(i)">
              <Trash/>
            </button>
          </div>

          <button class="gray" @click="addStudy">
            {{ $t('pages.profile.edit.profile.about.form.add-study-place') }}
          </button>
          <!--<button class="add-more">
                        <img src="@/assets/icons/plus-dark.svg" alt="">
                        <span>add more education</span>
                    </button>-->
          <input
              type="text"
              :placeholder="$t('pages.profile.edit.profile.about.form.placeholders.work-place')"
              v-model="form.work_place[0]"
          />
          <input
              type="text"
              :placeholder="$t('pages.profile.edit.profile.about.form.placeholders.position')"
              v-model="form.position"
          />
          <Tooltip :text="$t('pages.profile.edit.profile.about.form.specialization-tooltip')">
            <input
                type="text"
                :placeholder="$t('pages.profile.edit.profile.about.form.placeholders.specialization')"
                v-model="form.specialization"
            />
          </Tooltip>
          <div class="select-icon">
            <select v-model="form.country">
              <option :value="country" v-for="(country, i) in COUNTRIES" :key="i">{{ country }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="contact">
        <div class="block-title">{{ $t('pages.profile.edit.profile.contact.title') }}</div>
        <div class="inputs">
          <div class="input-select">
            <input
                type="tel"
                :placeholder="$t('pages.profile.edit.profile.contact.form.placeholders.phone')"
                v-model="form.phone"
            />
            <IsShowParam v-model="form.phone_visible"/>
          </div>
          <div class="input-select">
            <input
                type="email"
                :placeholder="$t('pages.profile.edit.profile.contact.form.placeholders.email')"
                v-model="form.email"
            />
            <IsShowParam v-model="form.email_visible"/>
          </div>
        </div>
      </div>
      <div class="social">
        <div class="block-title">{{ $t('pages.profile.edit.profile.social.title') }}</div>
        <div class="inputs">
          <label>
            <span><img src="~@/assets/icons/logos/Facebook.svg" alt="facebook"/></span>
            <input type="text" v-model="form.facebook_link"/>
          </label>
          <label>
            <span><img src="~@/assets/icons/logos/LinkedIn.svg" alt="LinkedIn"/></span>
            <input type="text" v-model="form.linkedin_link"/>
          </label>
          <label>
            <span><img src="~@/assets/icons/logos/Instagram.svg" alt="Instagram"/></span>
            <input type="text" v-model="form.instagram_link"/>
          </label>
        </div>
      </div>
    </div>
    <div class="actions">
      <button class="primary" @click="save" :disabled="pending.updateResult">
        {{ pending.updateResult ? $t('pages.profile.edit.actions.wait') : $t('pages.profile.edit.actions.save') }}
      </button>
      <router-link tag="button" :to="{ name: 'Profile' }">{{ $t('pages.profile.edit.actions.cancel') }}</router-link>
    </div>

    <p class="error-block" v-if="error.updateResultf">
      {{ error.updateResult }}
    </p>

    <ModalPhotoCrop @change="form.avatar = $event" :src="tmpAvatarUrl" @close="tmpAvatar = null"/>

    <Modal id="video-url" #default="{ close }">
      <h2>{{ $t('pages.profile.edit.upload-video.title') }}</h2>
      <input type="text" :placeholder="$t('pages.profile.edit.upload-video.placeholder')" v-model="form.video"/>
      <div class="actions">
        <button class="primary" @click="close">{{ $t('pages.profile.edit.upload-video.add') }}</button>
        <button @click="close">{{ $t('pages.profile.edit.upload-video.close') }}</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Avatar from '@/components/user/Avatar'
import Role from '@/components/user/Role'
import Birthdays from '@/components/form/Birthdays'
import InputFile from '@/components/form/InputFile'
import {mapActions, mapMutations, mapState} from 'vuex'
import Modal from '@/components/modals/Modal'
import {COUNTRIES} from '@/utils/_CONST'
import IsShowParam from '@/components/profile/IsShowParam'
import ModalPhotoCrop from '../../components/modals/ModalPhotoCrop'
import Tooltip from '@/components/Tooltip'
import Trash from "@/components/icons/Trash";
import locales from "@/locales";

export default {
  name: 'ProfileEdit',
  components: {Trash, Tooltip, ModalPhotoCrop, IsShowParam, Modal, InputFile, Birthdays, Role, Avatar},
  data: () => ({
    COUNTRIES,
    degreeCount: 1,
    tmpAvatar: null,
    activeLangKey: 'en',
    form: {
      localized_name: {},
      localized_surname: {},
      avatar: null,
      birthday: undefined,
      birthday_visible: true,
      degree: '',
      education: '',
      work_place: [''],
      study: [],
      position: '',
      specialization: '',
      description: '',
      facebook_link: '',
      linkedin_link: '',
      instagram_link: '',
      country: '',
      video: '',
      phone: '',
      phone_visible: true,
      email: '',
      email_visible: true,
    },
  }),
  computed: {
    langList() {
      return Object.keys(locales).sort((a, b) => (a === this.$i18n.locale ? -1 : 1))
    },
    videoUrl() {
      if (!this.form.video) return false
      if (typeof this.form.video === 'string') return this.form.video
      try {
        return URL.createObjectURL(this.form.video)
      } catch (e) {
        alert(e)
        console.warn(e, this.form.video)
        return false
      }
    },
    avatarUrl() {
      if (!this.form.avatar) return false
      try {
        return URL.createObjectURL(this.form.avatar)
      } catch (e) {
        return false
      }
    },
    tmpAvatarUrl() {
      try {
        return URL.createObjectURL(this.tmpAvatar)
      } catch (e) {
        return null
      }
    },
    user() {
      return this.$auth.user()
    },
    ...mapState('users', ['pending', 'error']),
  },
  methods: {
    deleteStudy(i) {
      this.form.study.splice(i, 1)
    },
    addStudy() {
      this.form.study.push('')
    },
    setVideo(file) {
      if (file && file.type.split('/')[0] === 'video') {
        this.form.video = file
      }
    },
    setAvatar(e) {
      this.tmpAvatar = e.target.files[0]
      this.openModal('materials-crop')
    },
    fillForm(user) {
      const exceptions = ['avatar']
      if (!Object.keys(user).length) return
      Object.keys(this.form).forEach((key) => {
        if (key === 'study') {
          if (user[key]) {
            this.form[key] = user[key].toString().split(',')
          } else {
            this.form[key] = ['']
          }
        } else if (!exceptions.includes(key)) {
          this.form[key] = user[key] ?? ''
        }
      })
      if (!this.form.work_place) {
        this.form.work_place = ['']
      }
    },
    save() {
      const isFile = (data) => data instanceof File || data instanceof Blob

      let data = new FormData()
      for (let filed in this.form) {
        let val = this.form[filed]
        if (typeof val === 'string' && !val.length) val = null
        if (filed == 'video' && !isFile(val)) continue
        if (filed == 'avatar') {
          if (isFile(val)) {
            data.append('upload', val)
          } else {
            continue
          }
        }
        if (typeof val === 'object') {
          if (val) {
            Object.entries(val).map(([k,v]) => {
              data.append(`${filed}[${k}]`, v)
            })
          }
        } else if (Array.isArray(val)) {
          if (!val[0]) {
            data.append(filed, 'false')
          } else data.append(`${filed}[]`, val ?? 'false')
        } else data.append(filed, val ?? 'false')
      }

      this.updateUser({data}).then(({data: user}) => {
        this.$auth.user(user)
        this.$router.push({
          name: 'Profile',
        })
      })
    },
    ...mapMutations(['openModal']),
    ...mapActions('users', ['updateUser']),
  },
  watch: {
    videoUrl() {
      const video = this.$refs.video
      if (video) {
        video.load()
      }
    },
    user: {
      immediate: true,
      handler(user) {
        this.fillForm(user)
      },
    },
  },
}
</script>

<style lang="scss">
#content.page-profile.edit {
  .tab-list {
    display: flex;
    margin-bottom: 12px;
    .item {
      border: 1px solid #DCDDDD;
      border-radius: 0;
      text-transform: uppercase;
    }
    .item:first-child {
      border-radius: 5px 0 0 5px;
    }
    .item:last-child {
      border-radius: 0 5px 5px 0;
    }
    .item.active {
      background: #003882;
      color: #ffffff;
      border-color: #003882;
    }
  }

  .user-block {
    @include mobile {
      margin-bottom: 0;
    }
  }

  .input-with-delete {
    display: flex;

    input {
      width: 100%;
    }

    button {
      width: auto !important;
      height: 44px !important;
      margin-bottom: 0 !important;
      margin-left: 8px;

      svg {
        margin-right: 0;
      }
    }
  }

  .profile-info {
    display: grid;
    grid-template-columns: auto;
    grid-gap: 40px;
  }

  .block-title {
    margin-bottom: 10px;

    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
    color: #474747;
  }

  .user-name-title {
    margin-bottom: 28px;

    font-weight: 700;
    font-size: 24px;
    line-height: 116%;
    letter-spacing: -0.01em;
    color: #474747;
  }

  .inputs {
    button {
      height: 40px;
      width: 100%;
      margin-bottom: 10px;
    }
  }

  .avatar-edit {
    @include mobile {
      margin-bottom: 27px;
    }
  }

  .error-block {
    margin: 10px 0;
    color: $primary;
  }

  .avatar-edit {
    position: relative;
    z-index: 3;
    float: left;
    cursor: pointer;
    transition: all 0.25s;

    &:hover {
      opacity: 0.75;
    }

    .btn-add {
      position: absolute;
      top: 84px;
      left: 84px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 35px;
      height: 35px;
      background: $primary;
      border-radius: 50%;
      cursor: pointer;

      img {
        margin: 0 !important;
      }
    }

    input {
      @include inputHide;
    }
  }

  .user-block {
    .about {
      margin-top: 0;
      padding-left: 18px;
    }

    .textarea {
      position: relative;

      textarea {
        padding: 22px 30px;
      }

      .max-char {
        position: absolute;
        bottom: 16px;
        right: 42px;

        font-weight: 700;
        font-size: 10px;
        line-height: 130%;
        color: #d0d0d0;

        @include mobile {
          right: 16px;
        }
      }

      .tooltip {
        top: 42px;
        right: 42px;

        @include mobile {
          display: flex;
          align-items: flex-end;

          bottom: 16px;
          left: 8px;
          right: unset;
          top: unset;
        }

        .tooltip-content {
          left: unset;
          right: -24px;

          &::after {
            left: unset;
            right: 24px;
          }
        }
      }
    }
  }

  .user-video-block {
    @include flexCenter();
    flex-direction: column;
    border: 1px solid $lightGray;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: $dark;
    max-width: 100%;

    &.input-file-custom {
      background: none;
      cursor: pointer;
      overflow: hidden;

      .video-preview {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        background: $white;
      }
    }

    .static {
      position: static;
      background-color: $bg;
      background-blend-mode: difference;
      margin-bottom: 16px;
    }

    .add {
      background-color: $primary;
      background-image: url('~@/assets/icons/plus.svg');
      transition: all 0.25s;
    }

    &:hover .add {
      background-color: $primary;
    }
  }

  .double-col {
    grid-template-columns: 1fr;
    grid-gap: 20px;
  }

  label {
    display: block;
    margin-bottom: 7px;

    input {
      margin-bottom: 0;
    }
  }

  input {
    display: block;
    margin-bottom: 15px;
  }

  button.add-more {
    @include flexCenter;

    width: 100%;
    margin-bottom: 15px;
    color: $text;
    font-weight: normal;
  }

  .social label {
    display: flex;
    align-items: center;

    span {
      @include flexCenter();
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      margin-right: 16px;
      background: rgba(204, 215, 230, 0.3);
      border-radius: 5px;
    }
  }

  .actions {
    grid-template-columns: 1fr 1fr;
  }

  @include PC {
    .user-block .about {
      max-width: calc(100% - 200px);
      margin-top: 22px;
    }

    input,
    button.add-more {
      margin-bottom: 8px;
    }

    //label,
    //input,
    //.input-select,
    //.select-icon,
    //button.add-more,
    //.inputs {
    //
    //  width: 100%;
    //}
    .input-select {
      display: flex;
      border: 1px solid #DCDDDD;
      border-radius: 10px;
      font-weight: 400;
      font-size: 15px;
      line-height: 125.5%;
      color: #474747;
      background-color: #ffffff;
      outline: none !important;
      width: 100%;
      margin-bottom: 8px;

      input {
        border: none;
        padding: 10px 12px;
        margin-bottom: 0;
      }
    }

    .inputs {
      max-width: 385px;
      display: flex;
      flex-direction: column;
    }

    .input-select {
    }

    .user-video-block {
      font-size: 14px;
      line-height: 19px;

      .static {
        width: 62px;
        height: 62px;
      }
    }

    > .actions {
      display: flex;
      margin-top: 40px;

      @include mobile {
        margin-top: 35px;
      }

      button {
        width: unset;
      }
    }
  }
}
</style>
